import script from "./ModalParametrosPrimeraRonda.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalParametrosPrimeraRonda.vue?vue&type=script&setup=true&lang=ts"

import "./ModalParametrosPrimeraRonda.vue?vue&type=style&index=0&id=83bf5b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83bf5b90"]])

export default __exports__